
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class GenericExplosionParticle extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    /* START-USER-CTR-CODE */
    const emitter = this.scene.add.particles(x, y, 'particles', {
            frame: [ 'particle-smoke-1.png','particle-smoke-2.png','particle-smoke-3.png','particle-smoke-4.png'],
            lifespan:500,
            speed: { min:50, max: 150 },
            scale: { start: 0.1, end:1 },
            alpha: { start: 1, end: 0 },
            rotate: { start: 0, end: 10 },
            gravityY: 0,
            
            emitting: false
        });

	emitter.explode(20);

  const emitterStars = this.scene.add.particles(x, y, 'particles', {
    frame: [ 'particle-star-pink.png','particle-star-red.png','particle-star-white.png','particle-star-yellow.png'],
    lifespan:500,
    speed: { min:200, max: 500 },
    scale: { start: 0.1, end:1 },
    alpha: { start: 1, end: 0 },
    rotate: { start: 0, end: 360 },
    gravityY: 0,
    
    emitting: false
  });
  emitterStars.explode(20);

    emitter.on('complete', () => {
      this.destroy(true);
    });
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
